import {writable} from 'svelte/store';
import type {CustomerDataType} from 'types/general';

const initialValue = {
    firstname: '',
    lastname: '',
    email: '',
    isSubscribed: false,
    isLoggedIn: false,
};

const createCustomerStore = () => {
    const {subscribe, set} = writable(<CustomerDataType>{...initialValue});

    return {
        subscribe,
        setData: (data: CustomerDataType) => set(data),
    };
};

export const customer = createCustomerStore();
